import React from 'react';
import PropTypes from 'prop-types';

const moveIcon2 = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4.5" cy="1.5" r="1.5" fill={color} />
    <circle cx="4.5" cy="7" r="1.5" fill={color} />
    <circle cx="4.5" cy="12.5" r="1.5" fill={color} />
    <circle cx="9.5" cy="1.5" r="1.5" fill={color} />
    <circle cx="9.5" cy="7" r="1.5" fill={color} />
    <circle cx="9.5" cy="12.5" r="1.5" fill={color} />
  </svg>
);

moveIcon2.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

moveIcon2.defaultProps = {
  width: 21,
  height: 21,
  color: '#3174EE',
};

export default moveIcon2;
